import { create } from 'zustand'
import type { FileItem } from '../types'

interface FileStore {
  files: FileItem[]
  activeFileId: string | null
  addFile: (file: FileItem) => void
  removeFile: (id: string) => void
  updateFile: (id: string, updates: Partial<FileItem>) => void
  setActiveFile: (id: string | null) => void
  getActiveFile: () => FileItem | undefined
}

const defaultFile: FileItem = {
  id: 'default',
  name: 'Untitled.md',
  content: '',
  createdAt: Date.now(),
  updatedAt: Date.now(),
  isFolder: false,
  parentId: null,
}

export const useFileStore = create<FileStore>((set, get) => ({
  files: [defaultFile],
  activeFileId: 'default',
  addFile: (file) => set((state) => ({ files: [...state.files, file] })),
  removeFile: (id) =>
    set((state) => ({
      files: state.files.filter((f) => f.id !== id),
      activeFileId: state.activeFileId === id ? (state.files[0]?.id ?? null) : state.activeFileId,
    })),
  updateFile: (id, updates) =>
    set((state) => ({
      files: state.files.map((f) => (f.id === id ? { ...f, ...updates, updatedAt: Date.now() } : f)),
    })),
  setActiveFile: (id) => set({ activeFileId: id }),
  getActiveFile: () => {
    const state = get()
    return state.files.find((f) => f.id === state.activeFileId)
  },
}))
